// Date formatters for the documents surfaces. Document timestamps render in the
// PROJECT's timezone — never the viewer's — in the ja-JP numeric style shared
// across the documents UI. Invalid input passes through untouched so a malformed
// upstream date string never throws.
//
// Previously pinned to Asia/Tokyo. Anchoring to the viewer was always wrong; so
// is anchoring to a fixed zone, which mislabels every document on a site outside
// it (and by a whole day for anything stamped near local midnight).
function dateOpts(tz: string): Intl.DateTimeFormatOptions {
  return { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: tz };
}

function dateTimeOpts(tz: string): Intl.DateTimeFormatOptions {
  return { ...dateOpts(tz), hour: '2-digit', minute: '2-digit', hour12: false };
}

export function formatProjectDate(iso: string, tz: string): string {
  const d = new Date(iso);
  return isNaN(d.getTime()) ? iso : new Intl.DateTimeFormat('ja-JP', dateOpts(tz)).format(d);
}

export function formatProjectDateTime(iso: string, tz: string): string {
  const d = new Date(iso);
  return isNaN(d.getTime()) ? iso : new Intl.DateTimeFormat('ja-JP', dateTimeOpts(tz)).format(d);
}
